
export interface IDTTSerial {
    selectPortAndConnect():Promise<any>;
}
export interface IMessageWorker {
    type: EWorker;
    data?: any;
    id?:number;
    host?:number;
}
/**
 * digitaltwins-service#602: the serial speed of the Leanbot link. The Leanbot firmware
 * opens its serial port at 115200 (digitaltwin-leanbot, Leanbot/src/Leanbot.h,
 * `_begin()`: `Serial.begin(115200)`), and the IDE uses the same speed. At 9600 the
 * gateway read nothing usable from the bot, so the mission name (`A <mission> ...` lines)
 * was never found and the flow stopped at the gateway.
 */
export const LEANBOT_SERIAL_BAUD_RATE = 115200;

export enum BOTSTATE {
    READY=0,
    BUSY=1
}
export enum EWorker {
  CONNECT = 1,
  WRITE = 2,
  BOTDATA = 3,
  CMD_DISCONNECT = 4,
  SET_OPTIONS = 5,
  CMD_SET_CURRENT_BOT = 6,
  CMD_GET_CURRENT_BOT = 7,
  

  
  NO_BOT = 9,
  BOT_AVAILABLE = 10,
  ON_CONNECTED = 11,
  EVENT_DISCONNECT=12,
  CMD_DISCONNECT_CURRENT_BOT=13,
  CMD_DISCONNECT_REQUEST=14,

  CMD_WORKER_START_BOT = 15,
  CMD_HOST_START_BOT = 16,

  CMD_WORKER_SEND_DATA = 17,
  CMD_HOST_SEND_DATA = 18,
  
  OK = 0,
  DEBUG = 900,
  ERROR = 999,
  CMD_PING = 1000,
  ALIVE = 1001,

  NONE = -1,
  
}
// time to notify share worker about current host status,
// if the host long time does not send this ping, then that worker has been kill by 'some thing' 
export const WORKER_PING_TIME=300;
export default ()=>{}